/* eslint-disable camelcase */
import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import styled from 'styled-components'
import { Label, Table, Button, Icon } from 'semantic-ui-react'

import utils from '../../../utils'

const ButtonWrapper = styled.div`
  margin-top: 3px;
  margin-bottom: 3px;
`

const DeviceInfo = styled(Label)`
  margin-left: 0;
  margin-top: 3px;
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 3px !important;
  padding-bottom: 4px !important;
  padding-top: 4px !important;
`

const ActionButton = ({ title, onClick, color }) => (
  <ButtonWrapper>
    <Button
      size="mini"
      color={color}
      onClick={onClick}
      style={{ width: 120, marginRight: 0 }}
    >
      {title}
    </Button>
  </ButtonWrapper>
)

const StatusLabel = ({ color, text, width = 80 }) => (
  <ButtonWrapper>
    <Label
      horizontal
      color={color}
      style={{ width, marginRight: 0 }}
    >
      {text}
    </Label>
  </ButtonWrapper>
)

const Battery = ({ driver }) => (
  <div>
    <Label
      size="medium"
      color={utils.helpers.getBatteryStatus(driver.battery).color}
      style={{ minWidth: 75 }}
    >
      <Icon name={utils.helpers.getBatteryStatus(driver.battery).icon} />
      {parseInt(driver.battery * 100, 10)}%
    </Label>
  </div>
)

class DriverRow extends React.Component {
  shouldComponentUpdate(nextProps) {
    const { driver, index } = this.props
    const { status, online, last_session, cash_balance, credit_balance, delivery_fee_rate, region } = driver

    return (
      index !== nextProps.index ||
      region !== nextProps.driver.region ||
      status !== nextProps.driver.status ||
      online !== nextProps.driver.online ||
      last_session !== nextProps.driver.last_session ||
      cash_balance !== nextProps.driver.cash_balance ||
      credit_balance !== nextProps.driver.credit_balance ||
      delivery_fee_rate !== nextProps.driver.delivery_fee_rate
    )
  }

  decorate = driver => ({
    driverName: `${driver.family_name} ${driver.first_name}`,
    packageSize: driver.package_size && driver.package_size.substring(0, 1).toUpperCase(),
    batteryColor: utils.helpers.getBatteryStatus(driver.battery).color,
    devicePlatformIcon: utils.helpers.getLoggedDevicePlatform(driver.loggedUUID, { marginRight: 5 }),
    codePushVersion: driver.code_push_version ? ` - ${driver.code_push_version}` : '',
    versionCode() { return driver.current_version && `${driver.current_version}${this.codePushVersion}` },
    createdAt: moment(driver.created_at).format('DD-MMM-YYYY HH:mm'),
    lastSession: driver.last_session ? moment(driver.last_session).fromNow() : '',
    onlineStatus: driver.online ? 'Online' : 'Offline',
    onlineButton: driver.online ? 'Go Offline' : 'Go Online',
    onlineStatusColor: driver.online ? 'green' : 'red',
    availability: driver.status === 'waiting_for_confirm' ? 'Pending' : _.capitalize(driver.status),
    availabilityColor: utils.helpers.getDriverStatusColor(driver.status),
    credit: `$ ${parseFloat(driver.credit_balance || 0).toFixed(2)}`,
    creditColor: utils.helpers.getCreditStatusColor(driver.credit_balance || 0),
    cash: `$ ${parseFloat(driver.cash_balance || 0).toFixed(2)}`,
    cashColor: utils.helpers.getCreditStatusColor(driver.cash_balance || 0),
  })

  render() {
    const { driver, index, onView, onEdit, onRemove, onGoOnlineOffline, driverSegment } = this.props
    const decoratedDriver = this.decorate(driver)

    return (
      <Table.Row>
        <Table.Cell>
          {`${index + 1}. ${decoratedDriver.driverName}`}
        </Table.Cell>

        <Table.Cell textAlign="center">
          <Label style={{ minWidth: 53, marginBottom: 3 }}>
            <Icon className="box" />
            {decoratedDriver.packageSize}
          </Label>
          <Label style={{ minWidth: 110, textAlign: 'center', marginBottom: 3 }}>
            {driver.tel}
          </Label>
          <Label style={{ minWidth: 110, textAlign: 'center', textTransform: 'uppercase' }}>
            {driver.region || utils.constants.REGION.PHNOM_PENH}
          </Label>
        </Table.Cell>

        <Table.Cell textAlign="center">
          {driver.battery && <Battery driver={driver}/>}
          {driver.current_version && (
            <DeviceInfo>
              {decoratedDriver.devicePlatformIcon}
              {decoratedDriver.versionCode()}
            </DeviceInfo>
          )}
        </Table.Cell>

        <Table.Cell textAlign="center">
          <StatusLabel text={`${driver.delivery_fee_rate} %`} />
          <StatusLabel
            text={decoratedDriver.credit}
            color={decoratedDriver.creditColor}
          />
          <hr />
          <StatusLabel
            text={decoratedDriver.cash}
            color={decoratedDriver.cashColor}
          />
        </Table.Cell>

        <Table.Cell textAlign="center">
          <ActionButton title={decoratedDriver.onlineStatus} onClick={onGoOnlineOffline} color={decoratedDriver.onlineStatusColor} />
          <StatusLabel
            width={120}
            text={decoratedDriver.availability}
            color={decoratedDriver.availabilityColor}
          />
        </Table.Cell>

        <Table.Cell textAlign="center">{driverSegment && <Label>{driverSegment.name}</Label>}</Table.Cell>
        <Table.Cell textAlign="center">{decoratedDriver.createdAt}</Table.Cell>
        <Table.Cell textAlign="center">{decoratedDriver.lastSession}</Table.Cell>
        <Table.Cell textAlign="center">
          <ActionButton title="View" onClick={onView} color="black" />
          <ActionButton title="Edit" onClick={onEdit} />
          <ActionButton title="Remove" onClick={onRemove} color="red" />
        </Table.Cell>
      </Table.Row>
    )
  }
}

export default DriverRow



// WEBPACK FOOTER //
// ./src/components/drivers/views/driverRow.js